module.exports = Promise.all([__parcel__import__("1fLRR"), __parcel__import__("20OqL")]).then(() => parcelRequire('g36Vt'));